module.exports = __webpack_public_path__ + "img/microsoft.d152fce5.png";